/**
 * H.J. Cave & Sons — Theme JavaScript
 * Scroll reveal, lazy loading, hover preload
 */
(function(){
'use strict';

// Scroll-reveal animation
const rvO = new IntersectionObserver(entries => {
  entries.forEach(e => {
    if (e.isIntersecting) {
      e.target.classList.add('vis');
      rvO.unobserve(e.target);
    }
  });
}, { threshold: 0.08, rootMargin: '0px 0px -30px 0px' });

document.querySelectorAll('.rv').forEach(el => rvO.observe(el));

// Lazy loading for data-src images (fallback for non-Shopify images)
const imgO = new IntersectionObserver(entries => {
  entries.forEach(e => {
    if (e.isIntersecting) {
      const img = e.target;
      if (img.dataset.src) {
        img.src = img.dataset.src;
        img.removeAttribute('data-src');
        img.onload = () => img.classList.add('loaded');
      }
      imgO.unobserve(img);
    }
  });
}, { rootMargin: '200px' });

document.querySelectorAll('img[data-src]').forEach(i => imgO.observe(i));

// Hover-preload product images
document.addEventListener('mouseover', e => {
  const card = e.target.closest('.pcard');
  if (!card || card._prefetched) return;
  card._prefetched = true;
  const link = card.querySelector('a');
  if (link && link.href) {
    const prefetch = document.createElement('link');
    prefetch.rel = 'prefetch';
    prefetch.href = link.href;
    document.head.appendChild(prefetch);
  }
});

})();
